import { render, staticRenderFns } from "./DetailSerieView.vue?vue&type=template&id=1cc6e76c&scoped=true"
import script from "./DetailSerieView.vue?vue&type=script&lang=js"
export * from "./DetailSerieView.vue?vue&type=script&lang=js"
import style0 from "./DetailSerieView.vue?vue&type=style&index=0&id=1cc6e76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6e76c",
  null
  
)

export default component.exports